<template>
  <div
    class="container"
  >
    <table class="customeTable">
      <thead class="customeTableHead">
        <tr class="customeTableHeadRow">
          <th style="width: 25%">
            {{ $t('forms.labels.wONumber') }}
          </th>
          <th style="width: 15%">
            {{ $t('forms.labels.date') }}
          </th>
          <th style="width: 15%">
            {{ $t('siteDashboard.woType') }}
          </th>
          <th style="width: 20%">
            {{ $t('siteDashboard.hoursWorked') }}
          </th>
          <th style="width: 10%">
            {{ $t('billing.labels.poNumber') }}
          </th>
          <th style="width: 10%">
            {{ $t('billing.labels.soNumber') }}
          </th>
          <th style="width: 15%" />
        </tr>
      </thead>
      <tbody class="customeTableContent">
        <tr
          v-for="(item, index) in fieldBillingService"
          :key="index"
          class="customeTableContentRow"
        >
          <td>{{ item.wONumber }}</td>
          <td>{{ item.wOdate }}</td>
          <td class="woType">
            <div class="woTypePoint" /><span>{{ item.woType }}</span>
          </td>
          <td>
            <div class="woType">
              <v-icon
                color="primary"
              >
                mdi-clock-outline
              </v-icon> <span>{{ item.hoursWorked }}</span>
            </div>
          </td>
          <td>{{ item.poNumber }}</td>
          <td>{{ item.soNumber }}</td>
          <td>
            <div
              v-if="item"
              class="edirect-icon"
              @click="goTo(item)"
            >
              <v-icon
                color="#154fe3"
              >
                mdi-arrow-top-right
              </v-icon>
              <span>go</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Pagination -->
    <UnbilledWorkOrderFooter
      :currentPage="pagination.currentPage"
      :totalPageCount="pagination.totalPageCount"
      @changePage="changePage($event)"
    />
  </div>
</template>

<script>

import workOrderStatusChoices from '@/constants/workOrderStatusChoices';
import { mapGetters } from 'vuex';
import UnbilledWorkOrderFooter from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/UnbilledWorkOrderFooter.vue';
import moment from 'moment/moment';

export default {
    name: 'FieldServiceWorkOrder',
    components: { UnbilledWorkOrderFooter },
    props: {
        workOrderType: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            fieldBillingService: [],
            pagination: {},
            queryParams: {
                page: 1,
                perpage: 4,
                completionStatus: workOrderStatusChoices.COMPLETED,
                billable: true,
                notInvoiced: true,
            },
        };
    },
    watch: {
        workOrderType: {
            handler(val) {
                if (val === 'tab2') {
                    this.changePage(1);
                }
            },
        },
    },
    mounted() {
        this.getFieldServiceWorkOrder();
        this.changePage(1);
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    methods: {
        async getFieldServiceWorkOrder() {
            this.queryParams = {
                ...this.queryParams,
                sites: [this.site.id],
            };
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined(this.queryParams, true);
            const { data } = await this.$rq.getBilling(cleanQueryParams);
            this.fieldBillingService = data.workOrders.docs.map(workOrder => ({
                ...workOrder,
                wONumber: workOrder.contractNumber,
                wOdate: workOrder.startDate ? this.$options.filters.formatDate(workOrder.startDate, 'L') : null,
                woType: workOrder.workOrderType.name ? workOrder.workOrderType.name : '',
                hoursWorked: workOrder.onSiteDurationHours ? this.convertTime(workOrder.onSiteDurationHours) : null,
                poNumber: workOrder.poNumber || null,
                soNumber: workOrder.soNumber || null,
            }));
            this.pagination = data.pagination;
        },
        convertTime(time) {
            const duration = moment.duration(time, 'hours');
            const formatted = `${Math.floor(duration.asHours())} h ${duration.minutes()} m`;
            return formatted;
        },
        goTo(item) {
            this.$router.push({
                name: 'WorkOrderView',
                params: {
                    workOrderId: item.id,
                    isEdition: true,
                },
            });
        },

        changePage(page) {
            if (this.queryParams.page < 1 || this.queryParams.page > this.queryParams.totalPageCount) return;
            this.pagination.currentPage = page;
            document.getElementById('prev').disabled = this.pagination.currentPage === 1;
            document.getElementById('next').disabled = this.pagination.currentPage === this.pagination.totalPageCount;
            document.getElementsByClassName('page').forEach((button, index) => {
                if (index + 1 === this.pagination.currentPage) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
            this.queryParams.page = page;
            this.getFieldServiceWorkOrder();
        },
    },
};


</script>


<style lang="scss" scoped>
@import "@/assets/styles/components/unbilliedWoStyle";
</style>
